<template>
  <div class="content">
    <div class="bodycontent">
      <!-- 头部菜单 -->
      <div class="option">
        <div class="left">
          <el-button icon="el-icon-plus" type="primary" @click="getEmp"
            >添加新员工</el-button
          >
        </div>
        <!-- <div class="right">
          <span>
            <el-input
              type="text"
              placeholder="员工名称"
              v-model="keyword"
              style="width:180px"
              clearable
            />
          </span>
          <span>
            <el-button type="primary" @click="search()">搜索</el-button>
          </span>
        </div> -->
      </div>
      <el-table :data="listData" height="100%">
        <el-table-column label="员工编号" prop="emp_no"></el-table-column>
        <el-table-column label="员工姓名" prop="name"></el-table-column>
        <el-table-column label="联系电话" prop="mobile"></el-table-column>
        <el-table-column label="所属门店" prop="room"></el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="120px"
        >
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="editItem(scope.row.id)"
              >编辑</el-button
            > -->
            <el-button type="text" @click="delItem(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页按钮 -->
      <div class="Otherpage">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <!--  -->
    <el-dialog title="选择添加员工" :visible.sync="dialogEmp" width="30%">
      <el-select v-model="emp_id">
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in empList"
          :key="index"
          >{{ item.name }}
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogEmp = false">取 消</el-button>
        <el-button type="primary" @click="choseEmp">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { employeeListCar, employeeDel, employeeBind } from "@/api/carWash";
import { employeeList } from "@/api/employee";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      dialogEmp: false,
      emp_id: "",
      empList: [],
      presentId: "",
      listData: [], //列表
      keyword: "", //关键字筛选
      page: 1,
      total: 0,
      loading: false //页面loading
    };
  },
  mounted() {
    this.presentId = this.$route.query.type;
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        id: this.presentId,
        page: this.page
      };
      employeeListCar(data).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.listData = res.data;
          // this.listData.forEach(item => {});
          // this.total = res.total;
        } else {
          // this.();
        }
        this.loading = false;
      });
    },
    getEmp() {
      this.dialogEmp = true;
      var data = {
        token: this.token,
        app_id: this.app_id
        // id: this.presentId
      };
      employeeList(data).then(res => {
        console.log("员工", res);
        if (res.code == 200) {
          this.empList = res.data;
        }
      });
    },
    choseEmp() {
      if (!this.emp_id) {
        this.$message.warning("请选择要添加为本门店的员工！！");
        return;
      }
      var data = {
        token: this.token,
        app_id: this.app_id,
        room_id: this.presentId,
        emp_id: this.emp_id
      };
      employeeBind(data).then(res => {
        console.log("员工", res);
        if (res.code == 200) {
          this.empList = res.data;
          this.$message.success(res.msg);
          this.getData();
        } else {
          this.$message.warning(res.msg);
        }
        this.dialogEmp = false;
      });
    },
    search() {
      this.page = 1;
      this.getData();
    },
    //跳页
    handleCurrentChange(p) {
      this.page = p;
      this.getData();
    },
    //编辑
    editItem(id) {
      this.$router.push({
        path: "employeeAdd",
        query: { sid: id, type: this.presentId }
      });
    },
    //新增
    addEmployee() {
      this.$router.push({
        path: "employeeAdd",
        query: { type: this.presentId }
      });
    },
    //删除
    delItem(i) {
      this.$confirm("确定删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {
            token: this.token,
            app_id: this.app_id,
            emp_id: i
          };
          employeeDel(data).then(res => {
            if (res.code == 200) {
              this.getData();
              this.$message({
                type: "success",
                message: "删除成功"
              });
            } else {
              this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch();
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 0px 27px 0;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    display: flex;
    flex-direction: column;
    .option {
      height: 79px;
      line-height: 79px;
      display: flex;
      .left {
        flex: 1;
      }
      .right {
        text-align: right;
        span {
          margin-left: 30px;
          .el-select {
            width: 150px;
          }
        }
      }
    }
    // table
    .el-table {
      flex: 1;
      box-shadow: 0 0 3px #f1f1f1;
      padding-left: 10px;
    }
    .level_img {
      width: 40px;
      height: 40px;
      border-radius: 20px;
    }
    //表格中的商品内容
    .table_line {
      height: 20px;
      line-height: 20px;
      white-space: space wrap;
    }
    //分页
    .Otherpage {
      height: 34px;
      width: 200px;
      line-height: 34px;
    }
  }
}
</style>
